export enum SignalrMessageType {
  OnConnectionShutdown = 'OnConnectionShutdown',
  OnReportData = 'OnReportData',
}
